export default function getAppPublicPath() {
  return `/${process.env.APP_ID!}`;
}
